import { load as loadCashfreeSdk } from "@cashfreepayments/cashfree-js";
import { createPaymentOrder } from "./api";
import { PaymentType } from '../utils/paymentTypes';

function isTokenExpired(token) {
  try {
    const [, payloadBase64] = token.split('.');
    const payload = JSON.parse(atob(payloadBase64));
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    return payload.exp && payload.exp < now;
  } catch (e) {
    console.error("Failed to decode token:", e);
    return true;
  }
}
export const initializePayment = async ({ type, amount, token, returnUrl }) => {
  if (token && isTokenExpired(token)) {
    console.warn("Token is expired or invalid. Aborting payment.");
    window.location.href = "/";
    return;
  }

  let customerEmail = "user@example.com";
  let customerPhone = "9999999999";
  let userId = "unknown";
  let name = "User";

  /* -----------------------------
      1️⃣ EVENT REGISTRATION PAYMENT
  ------------------------------ */
  if (type === PaymentType.EVENT) {
    const raw = sessionStorage.getItem("event_registration");
    const data = JSON.parse(raw);

    if (!data) throw new Error("Missing event registration data");

    customerEmail = data.email;
    customerPhone = data.phone;
    userId = data.founderId || "unknown";
    name = data.name;
  }

  /* -------------------------------------
      2️⃣ STARTUP IDEAS SESSION PAYMENT
  -------------------------------------- */
  else if (type === PaymentType.STARTUP_IDEAS) {
    const raw = sessionStorage.getItem("startup_session_booking");
    const data = JSON.parse(raw);

    if (!data) throw new Error("Missing startup session data");

    customerEmail = data.email;
    customerPhone = data.phone;
    userId = data.userId || "unknown";
    name = data.name;
  }else if(type==PaymentType.MENTOR_MEETING){
      const raw = sessionStorage.getItem("mentor_meeting_booking");
    const data = JSON.parse(raw);

    if (!data) throw new Error("Missing startup session data");

    customerEmail = localStorage.getItem("email");
    customerPhone = localStorage.getItem("userPhone");
    userId = localStorage.getItem("startupId") || userId;
    name = localStorage.getItem("startupName") || name;
  }

  /* -----------------------------
      3️⃣ FALLBACK FOR ANY OTHER TYPE
  ------------------------------ */
  else {
    customerEmail = localStorage.getItem("email") || customerEmail;
    customerPhone = localStorage.getItem("userPhone") || customerPhone;
    userId = localStorage.getItem("startupId") || userId;
    name = localStorage.getItem("startupName") || name;
  }

  /* -----------------------------
      4️⃣ CREATE PAYMENT ORDER
  ------------------------------ */
  const paymentData = await createPaymentOrder(
    {
      amount,
      userId,
      customer_details: {
        email: customerEmail,
        phone: customerPhone,
        customer_name: name,
      },
      return_url: returnUrl,
    },
    token
  );

  if (!paymentData.paymentSessionId) {
    throw new Error("No paymentSessionId received");
  }

  /* -----------------------------
      5️⃣ LOAD CASHFREE SDK
  ------------------------------ */
  await loadCashfreeSdk({
    mode: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox'
  });

  // 3. Initialize checkout
  const cf = window.Cashfree({ mode: "production" });;

  /* -----------------------------
      6️⃣ START CHECKOUT
  ------------------------------ */
  return new Promise((resolve, reject) => {
    cf.checkout({
      redirectTarget: "_self",
      paymentSessionId: paymentData.paymentSessionId,
      returnUrl: `${returnUrl}/${type}/${paymentData.orderId}`,
      onSuccess: (data) => {
        resolve({
          orderId: paymentData.orderId,
          paymentId: data.cf_payment_id,
          method: data.payment_method,
          raw: data,
        });
      },
      onFailure: (err) => reject(new Error(err.message || "Payment failed")),
      onClose: () => reject(new Error("Payment popup closed")),
    });
  });
};
